import { TASK_TYPES } from 'redesign/components/templates/ContentLists/TaskList/constants'

export const DEFAULT_TIMELINE_ITEMS_IDS = {
  [TASK_TYPES.absenceRequest]: 'absenceRequest',
  [TASK_TYPES.monthlySheet]: 'defaultDocumentItem',
  [TASK_TYPES.shareUserData]: 'defaultFormItem',
}
